export type UserInfoPropsTypes = {
  userName: string;
  accountNo: string;
  expiryDate: string;
  customGreeting?: string;
  sourceType: UserInfoSourceType;
};

export enum UserInfoSourceType {
  ME_PANEL = 'me_panel',
  ACCOUNT_DASHBOARD = 'account_dashboard',
}
